export default "__VITE_ASSET__Cy4kw1uF__"